// extracted by mini-css-extract-plugin
module.exports = {"base":"InteractiveTask_base__Wi2pr","barContainer":"InteractiveTask_barContainer__C9PBb","contentContainer":"InteractiveTask_contentContainer__3EpkM"};